module.exports = __webpack_public_path__ + "h5/img/mfe_11.4743fa27.jpg";